import React, { useEffect } from 'react';
import s from './TopMenu.module.scss';
import { ReactComponent as NotificationIcon } from 'images/notification-gray.svg';
import { ReactComponent as Bag } from 'images/dark-green-cart.svg';
import { useNavigate } from 'react-router-dom';
import useIsAuth from 'sdk/hooks/useIsAuth';
import useGetOrdersInTheCart from 'sdk/hooks/shop/useGetOrdersInTheCart';
import { useTranslation } from 'react-i18next';

const TopMenuForShop = ({ onOpen }) => {
  const {t} = useTranslation() as any
  const navigate = useNavigate();
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;
  const { data: cartItems, refetch: refetchCart } = useGetOrdersInTheCart(userId);

  useEffect(() => {
    refetchCart();
  }, [userId]);

  interface CartItem {
    count: number;
  }
  const itemCount = (cartItems as CartItem[] | undefined)?.reduce((total: number, item: CartItem) => total + (item.count || 0), 0) || 0;
  const displayCount: string | number = itemCount > 9 ? '9+' : itemCount;

  return (
    <div className={s.container}>
      <NotificationIcon
        className={s.container_notification_icon}
        onClick={() => navigate('/user-notifications')}
      />
      <div className={s.container_title}>{t('Shop')}</div>
      <div className={s.container_right_icons}>
        <div className={s.cart_wrapper} onClick={() => onOpen(false)}>
          <Bag />
          {itemCount > 0 && <div className={s.counter}>{String(displayCount)}</div>}
        </div>
      </div>
    </div>
  );
};

export default TopMenuForShop;
